import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import * as _ from 'underscore';
import { Pagination } from '../../../models/pagination';
import { PeopleService } from '../../../services/people.service';
import { Person } from '../../../models/person';
import { InstanceTypes } from '../../../models/instance-types';

@Component({
  selector: 'app-people-search',
  templateUrl: './people-search.component.html',
  styleUrls: ['./people-search.component.css'],
  standalone: false
})
export class PeopleSearchComponent implements OnInit {
  clientCode: string;
  people: Person[];
  minSearchLength = 1;
  pagination: Pagination;
  searchQuery = '';

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }
  constructor(
    private route: ActivatedRoute,
    private peopleService: PeopleService,
    @Inject('env') private env: any
  ) {
    this.search = _.debounce(this.search, 250);
  }

  loadPage({ Page }: Pagination) {
    this.peopleService
      .searchPeople(this.clientCode, {
        query: this.searchQuery,
        pageNumber: Page,
        perPage: 50
      })
      .subscribe(resp => {
        this.people = resp.Items;
        this.pagination = resp.Pagination;
      });
  }

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('client_code');
    if (this.clientCode == null) {
      this.clientCode = this.route.parent.snapshot.paramMap.get('client_code');
    }
    this.searchQuery = this.route.snapshot.paramMap.get('search_query');

    if (this.searchQuery) {
      this.search();
    }
  }

  search() {
    if (!this.searchQuery || this.searchQuery.length < this.minSearchLength) {
      this.people = [];
    } else {
      this.peopleService
        .searchPeople(this.clientCode, {
          query: this.searchQuery,
          pageNumber: 1,
          perPage: 50
        })
        .subscribe(data => {
          if (data && data.Items) {
            this.people = data.Items;
            this.pagination = data.Pagination;
          } else {
            this.people = [];
          }
        });
    }
  }
}
